module.exports = __webpack_public_path__ + "static/media/ic_close_black_18px.5ef2a0fa.svg";